import React, { PureComponent, PropTypes } from 'react';

export function shortRecruitName(recruit, withYear = false) {
  const { firstName, lastName, year } = recruit;
  let output = '';

  if (firstName && lastName) {
    output = `${firstName[ 0 ]}. ${lastName}`;
  } else if (firstName) {
    output = firstName;
  } else if (lastName) {
    output = lastName;
  }

  if (withYear && year) {
    const abbreviatedYear = `${(`${year}`)[ 2 ]}${(`${year}`)[ 3 ]}`;
    output += ` '${abbreviatedYear}`;
  }

  return output;
}

export default class ShortRecruitName extends PureComponent {

  static propTypes = {
    bold: PropTypes.bool,
    recruit: PropTypes.shape({
      firstName: PropTypes.string,
      lastName: PropTypes.string
    }).isRequired,
    withYear: PropTypes.bool
  };

  static defaultProps = {
    bold: false,
    withYear: false
  };

  render() {
    const { bold, className, recruit, withYear } = this.props;
    const name = shortRecruitName(recruit, withYear);

    if (bold) {
      return <strong className={className}>{name}</strong>;
    } else {
      return <span className={className}>{name}</span>;
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/components/ShortRecruitName.jsx